export const HOSTNAME =
    `${process.env.NEXT_PUBLIC_AD_FRONT_APP_HOST}`?.slice(0, -1) +
    `${process.env.NEXT_PUBLIC_ENV_PREFIX}`;

// 404 Meta Tags
export const META_404_TITLE =
    'Data Not Found ✓ ACKO Drive - Online - Discounted Price';
export const META_404_DESCRIPTION =
    'ACKO Drive ✓ Discounted Price ✓ Specs ✓ Photos from ACKO Drive.';
